import React from "react";
import { Form, FormGroup, Input } from "reactstrap";

class DropdownSelect extends React.Component {
  render() {
    const { category, name, handleChange } = this.props;
    category.sort((a, b) => a.name.localeCompare(b.name, 'en', { numeric: true }));

    const optionValues = category
      ? category.map((element, index) => (
          <option key={element._id} value={element._id}>
            {`${element.name}`}
          </option>
        ))
      : null;

    return (
      <Form>
        <FormGroup>
          <Input
            type="select"
            name={name}
            id="exampleSelect"
            onChange={event => handleChange(event)}
          >
            <option value={null}>
              Select a Category
            </option>
            {optionValues}
          </Input>
        </FormGroup>
      </Form>
    );
  }
}

export default DropdownSelect;



// WEBPACK FOOTER //
// ./components/DropdownSelect1/index.js